import { apiEndpoint } from ".";

export async function getAuth(token: string | null) {
  const myHeaders = new Headers({
    "Oauth-Token": token ?? "",
    Authorization: token ?? "",
  });
  const response = await fetch(`${apiEndpoint}/get-token`, {
    method: "POST",
    headers: myHeaders,
    credentials: "include",
  });
  const responseJson = await response.json();
  try {
    return JSON.parse(responseJson);
  } catch {
    return responseJson.response;
  }
}

export async function refreshToken() {
  const headers = new Headers({
    "Oauth-Token": localStorage.getItem("refreshToken") ?? "",
    Authorization: localStorage.getItem("refreshToken") ?? "",
  });
  const response = await fetch(`${apiEndpoint}/refresh-token`, {
    method: "POST",
    credentials: "include",
    headers,
    body: JSON.stringify({
      token: localStorage.getItem("refreshToken"),
    }),
  });
  const responseJson = await response.json();
  try {
    return JSON.parse(responseJson);
  } catch {
    return responseJson.response;
  }
}

export async function logout() {
  try {
    await fetch(`${apiEndpoint}/logout`, {
      method: "POST",
      credentials: "include",
    });
  } finally {
    localStorage.clear();
    sessionStorage.clear();
  }
}
